import React, { useEffect } from 'react';
import '../PlatformCostObs/dashboard.scss';
import PageHeader from 'components/Header/Page';
import { powerBIdashboardUrl } from '../../service/config';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AnalyticsVisualization from '../framework/analyticsVisualization';
import BIApplicationIcon from '../../assets/biApplication.svg';
import PageWrapper from 'components/Common/PageWraper';
import { useTheme } from "@mui/material/styles";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

const CostManagementFinancialAnalysis = () => {
    const theme = useTheme();
    const colors = theme.palette;
    const [value, setValue] = React.useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (window.location.pathname.includes('/databricksADB')) {
            document.head.classList.add('theme-bg-blue');
            document.body.classList.add('theme-bg-blue');
        }
    }, []);

    return (
        // <div className="base-tab">
        <PageWrapper>
            <PageHeader title="Cost Management & Financial Analysis Dashboards" icon={BIApplicationIcon}> </PageHeader>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons={false}
                    aria-label="basic tabs example"
                    sx={{
                        '& .MuiTab-root': {
                            ...theme.typography.tabLabel,
                            textTransform: 'none',
                            minHeight: 40,
                            width: 309,
                            borderTopLeftRadius: 4,
                            borderTopRightRadius: 4,
                            display: 'flex',
                            position: 'relative',
                            backgroundColor: `${colors.Tab.inActive.bgColor} !important`,
                            color: '#FFFFFF !important',
                        },
                        '& .MuiTab-root.Mui-selected': {
                            backgroundColor: '#FFFFFF !important',
                            color: '#39ACE7 !important',
                        },
                        '& .MuiTabs-indicator': {
                            display: 'none',
                        },
                        '& .MuiTab-root.Mui-selected::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            height: '4px',
                            backgroundColor: '#39ACE7',
                        },
                    }}
                >
                    <Tab label="Cost Analysis" {...a11yProps(0)} />
                    <Tab label="SQL Cost Analysis" {...a11yProps(1)} />
                    <Tab label="Query Level Cost" {...a11yProps(2)} />
                    <Tab label="Resource Utilization" {...a11yProps(3)} />
                    <Tab label="Standardization Metrics" {...a11yProps(4)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <AnalyticsVisualization
                    params={{
                        dashboardUrl: powerBIdashboardUrl.CostAnalysisDashboard,
                        className: 'powerBiIframeContainer',
                        otherParams: {
                            name: 'PowerBI'
                        },
                        seamless: true
                    }}
                />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <AnalyticsVisualization
                    params={{
                        dashboardUrl: powerBIdashboardUrl.DBSQLCostAnalysisDashboard,
                        className: 'powerBiIframeContainer',
                        otherParams: {
                            name: 'PowerBI'
                        },
                        seamless: true
                    }}
                />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                <AnalyticsVisualization
                    params={{
                        dashboardUrl: powerBIdashboardUrl.QueryLevelCostAnalysisDashboard,
                        className: 'powerBiIframeContainer',
                        otherParams: {
                            name: 'PowerBI'
                        },
                        seamless: true
                    }}
                />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
                <AnalyticsVisualization
                    params={{
                        dashboardUrl: powerBIdashboardUrl.ResourceUtilizationAnalysisDashboard,
                        className: 'powerBiIframeContainer',
                        otherParams: {
                            name: 'PowerBI'
                        },
                        seamless: true
                    }}
                />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4}>
                <AnalyticsVisualization
                    params={{
                        dashboardUrl: powerBIdashboardUrl.StandardizationMetricsDashboard,
                        className: 'powerBiIframeContainer',
                        otherParams: {
                            name: 'PowerBI'
                        },
                        seamless: true
                    }}
                />
            </CustomTabPanel>
        </PageWrapper>
    );
};

export default CostManagementFinancialAnalysis;
